/**
 * «Энэ гутлыг яг одоо зарж болох уу» — касс ба POS-ын НЭГ хаалга.
 *
 * ⚠️ Эцсийн шийдвэрийг СЕРВЕР гаргана (төлөв, байршил, `trg_item_not_sold`).
 *    Энд байгаа нь зөвхөн ажилтанд ШАЛТГААНЫГ шууд хэлэх зорилготой —
 *    маягт бөглөж дуусаад 422 авахаас нэг скан хямд.
 *
 * ⚠️ Хоёр клиент (вэбийн `/sales`, гар утасны салбарын горим) ижил
 *    мессеж харуулна: касс дээр «болохгүй» гээд POS дээр «болно» гэвэл
 *    ажилтан алийг нь ч итгэхээ болино.
 */
/**
 * Яагаад зарж болохгүйг ажилтанд ойлгомжтой хэлнэ. Зарж болно = `null`.
 *
 * `store` өгвөл гутал ТЭР салбарт байгаа эсэхийг шалгана. Вэбийн касс
 * дээр ADMIN салбараа сонгоогүй байж болох тул заавал биш.
 *
 * ⚠️ `COLLECTED` нь «агуулахад ороогүй» гэсэн үг БИШ. Гутал агуулахад
 *    хүлээн авагдаад ч `WAREHOUSE_INTAKE` (зарагдахгүй байршил) дээр
 *    байвал `COLLECTED` хэвээр үлддэг — `AVAILABLE` нь ЗАРАГДАХ
 *    байршилд орох мөчид тавигддаг (`items.ts`, дүрэм №9). Тиймээс
 *    төлөв биш БАЙРШЛЫГ нь хэлнэ: ажилтан юу хийхээ мэдэх ёстой.
 *
 *    Бодит тохиолдол (2026-09-19): шилжүүлгийг уншуулалгүй хаасан тул
 *    9 гутал «Салбар хооронд замд» гацаж, касс дээр «агуулахад хүлээн
 *    авагдаагүй» гэж гарсан нь худал мессеж байв.
 */
export function sellableReason(item, store) {
    const { status, location } = item;
    // `RETURNED` = «Дахин зарна» гэж буцаагдсан, тавиур дээрээ — ЗАРАГДАНА
    // (сервер `lib/sellable.ts` SELLABLE_STATUSES). 2026-10-12 хүртэл энд
    // «эхлээд шалгана уу» гэж хаадаг байсан тул солилцоогоор буцаж ирсэн гутал
    // касс, POS аль алинд нь гарахгүй байв (23609034111). Гэмтэлтэй буцаалт
    // `DEFECTIVE` болдог тул энд хамаарахгүй.
    if (status !== 'AVAILABLE' && status !== 'RETURNED') {
        if (status === 'COLLECTED') {
            if (location?.type === 'TRANSIT_INTERNAL') {
                return 'шилжүүлгээр замд яваа — «Хүлээн авах» дээр уншуулж, хүлээн авалтыг хаана уу';
            }
            return location
                ? `«${location.name}»-д байна — энэ салбарт хүлээн авагдаагүй`
                : 'агуулахад хүлээн авагдаагүй байна';
        }
        switch (status) {
            case 'SOLD':
                return 'аль хэдийн зарагдсан';
            case 'RESERVED':
                return 'захиалагдсан';
            case 'DEFECTIVE':
                return 'гэмтэлтэй гэж тэмдэглэгдсэн';
            case 'WRITTEN_OFF':
                return 'актлагдсан';
            default:
                return `${status} төлөвтэй`;
        }
    }
    if (!location?.isSellable)
        return 'зарагдах байршилд байхгүй';
    if (store && location.storeId !== store.id)
        return `${store.name}-д байхгүй`;
    // 0₮ гутал касст гарвал орлого алдагдана — сервер ч хаана
    if (Number(item.priceMnt) <= 0)
        return 'үнэ тавигдаагүй — эхлээд үнэ тогтооно уу';
    return null;
}
//# sourceMappingURL=sellable.js.map